import { Enumeration } from '@bp/shared/models/core/enum';

export class UiExperiment extends Enumeration {

	static showPhoneInputInsteadIndustryInput = new UiExperiment();

	static showLeadPhoneInput = new UiExperiment();

}
